import { render, staticRenderFns } from "./ParentHomePage.vue?vue&type=template&id=c25994f4&"
import script from "./ParentHomePage.vue?vue&type=script&lang=js&"
export * from "./ParentHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports